import isEmpty from 'lodash-es/isEmpty';

import { isNullOrUndefined } from '@app/util/util';
import { ProvincesAndCitiesExternal, ProvincesByCity } from '@app/entities/provinces-cities';

export function getProvincesByCity(provincesRelation: ProvincesAndCitiesExternal): ProvincesByCity[] {
  if (!isEmpty(provincesRelation?.CitiesRelation) && !isEmpty(provincesRelation?.Provinces)) {
    const provinces = formatProvinces(provincesRelation?.Provinces)
      .filter(province => province.code.length > 1)
      .sort((a, b) => {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
    const citiesRelation = provincesRelation?.CitiesRelation
      .filter(cityRelation => !isNullOrUndefined(cityRelation.ProvinceId));
    return provinces.map(province => ({
      ProvinceCode: province.code,
      ProvinceName: province.name,
      Cities: citiesRelation
        .filter(relation => relation.ProvinceId === province.code)
        .map(relation => ({
          CityCode: relation.CityCode,
          CountryCode: relation.CountryCode
        }))
    })).filter(province => !!province.Cities.length);
  } else return [];
}

function formatProvinces(provinces: string[]): { name: string, code: string }[] {
  return provinces.map(province => {
    const parts = province.split('(');
    const code = parts[1].replace(')', '');
    const name = parts[0].replace(/\s*$/, '');
    return { name, code };
  });
}
